<template lang="pug">
  main
    NavBarInventario
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns.has-text-centered.has-text-dark
          .column
            h1.is-size-3 {{ title }}
              | 
              a.button.is-black.is-rounded(@click="backToPage")
                i.fas.fa-times
            br
        .columns.is-centered.has-text-dark
          .column.card-item.is-2-desktop.is-2-tablet.is-12-mobile.has-text-centered(v-show="verAlmacen")
            span.icon.is-large.is-size-6
              span.fa-stack.fa-lg
                i.fas.fa-circle.fa-stack-2x
                i.fas.fa-clipboard-list.fa-stack-1x.fa-inverse
            p.has-text-weight-medium.is-size-5 Artículos
            br
            router-link.a.button.is-dark.is-rounded.is-size-6(to="/Inventario/Almacen/Articulos") Entrar
          .column.card-item.is-2-desktop.is-2-tablet.is-12-mobile.has-text-centered(v-show="verAlmacen")
            span.icon.is-large.is-size-6
              span.fa-stack.fa-lg
                i.fas.fa-circle.fa-stack-2x
                i.fas.fa-clipboard-list.fa-stack-1x.fa-inverse
            p.has-text-weight-medium.is-size-5 Consumibles
            br
            router-link.a.button.is-dark.is-rounded.is-size-6(:to="almacenSelect === '' ? '/Inventario/Almacen/Consumibles' : '/Inventario/Consumibles'") Entrar
</template>


<script>
  import Loader from '@/components/shared/Loader.vue'
  import NavBarInventario from './layout/NavBarInventario.vue'
  import { mapState } from 'vuex'

  export default {
    name: 'SubMenuEntradas',
    components: { Loader, NavBarInventario },
    data() {
      return {
        isLoading: false,
        verAlmacen: false,
        verAsignaciones: false,
        verPrestamos: false,
        verSalidas: false,
        title: '',
      }
    },
    methods: {
      irSalidas(tipo) {
        this.$store.commit('selectSalida', tipo)
        this.$router.push( {path: '/Inventario/Busqueda'})
      },
      obtenerUser() {
        if (Object.keys(this.userLogin).length === 0) {
          this.$router.push('/')
        } else {
          switch (this.userLogin.cargo) {
            case '000':
              this.verAlmacen = true
              this.verAsignaciones = true
              break
            case '002':
              this.verAlmacen = true
              
              break
            case '003':
              this.verAlmacen = true
              break
            case '2100':
              this.verAlmacen = true
              break
            case '2200':
              this.verAlmacen = true
              break
            case '330':
              this.verAlmacen = true
              this.verSalidas = true
              this.verPrestamos = true
              this.verAsignaciones = true
              break
            case '331':
              this.verAlmacen = true
              this.verSalidas = true
              this.verPrestamos = true
              this.verAsignaciones = true
            break
            case '332':
              this.verAlmacen = true
              this.verSalidas = true
              this.verPrestamos = true
              this.verAsignaciones = true
            break
            case '160':
              break
            case '230':
              this.verAlmacen = true
              this.verAsignaciones = true
              break
            case '210':
              this.verAlmacen = true
              this.verAsignaciones = true
              break
            case '240':
              this.verAsignaciones = true
              break
            case '241':
              this.verAlmacen = true
              this.verAsignaciones = true
              this.verSalidas = true
              this.verPrestamos = true
              break
            case '310':
              this.verAlmacen = true
              this.verAsignaciones = true
              break
            case '321':
              this.verAlmacen = true
              this.verAsignaciones = true
              this.verSalidas = true
              this.verPrestamos = true
              break
            case '323':
              this.verAlmacen = true
              this.verAsignaciones = true
              this.verSalidas = true
              this.verPrestamos = true
              break
            case '324':
              this.verAlmacen = true
              break
            case '341':
              this.verAsignaciones = true
              break
            case '342':
              this.verAsignaciones = true
              break
            case '343':
              this.verAsignaciones = true
              break
            case '350':
              this.verAsignaciones = true
              break
            case '250':
              this.verAsignaciones = true
              break
            case '370':
              this.verAsignaciones = true
              break
            case '372':
              this.verAlmacen = true
              this.verAsignaciones = true
              this.verSalidas = true
              this.verPrestamos = true
              break
            case '270':
              this.verAsignaciones = true
              break
            default:
              this.verAlmacen = false
              this.verAsignaciones = false
              this.verPrestamos = false
              this.verSalidas = false
              break
          }
        }
      },

      irPrestamos() {
        this.$store.commit('showAreaAsignacion', '')
        this.$router.push('/Inventario/Prestamos')
      },
      backToPage () {
        this.$router.back()
      }
    },
    computed: {
    ...mapState(['logueado', 'userLogin'])
    },
    created () {
      this.obtenerUser()
      switch (this.almacenSelect) {
        case 'TPA-ALS':
          this.title = 'Almacén Entradas TPA GIA'
          break
        case 'EB04-ALG':
          this.title = 'Almacén Entradas EB04 GIA'
          break
        case 'CORP-ALG':
          this.title = 'Almacén Entradas Corporativo GIA'
          break
        case 'IRGE-ALM':
          this.title = 'Almacén Entradas IRGE'
          break
        case 'CORP-ALM':
          this.title = 'Almacén Entradas Corporativo'
          break
        case 'TPA-ALM':
          this.title = 'Almacén Entradas TPA'
          break
        case 'EB04-ALM':
          this.title = 'Almacén Entradas EB04'
          break
        case 'EB00-ALM':
          this.title = 'Almacén Entradas EB00'
          break
        case 'EB01-ALM':
          this.title = 'Almacén Entradas EB01'
          break
        case 'EB02-ALM':
          this.title = 'Almacén Entradas EB02'
          break
        case 'EB03-ALM':
          this.title = 'Almacén Entradas EB03'
          break
        case 'ERM-ALM':
          this.title = 'Almacén Entradas ERM'
          break
        default:
          this.title = 'Almacenes Entradas'
          break
        }
    },
    computed: {
      ...mapState(['userLogin', 'almacenSelect'])
    }
  }
</script>

<style lang="scss" scoped>
  .card-item:hover {
    transform: translateY(-5px) scale(1.005) translateZ(0);
    box-shadow: 0 24px 36px rgba(0,0,0,0.11), 0 14px 16px rgba(0,0,0,0.11);
  }
</style>


// WEBPACK FOOTER //
// src/components/inventario_Componentes/SubMenuEntradas.vue